import { createContext } from "react";
export const SoketContext: any = createContext(null);
export const DisplayRoleContext: any = createContext({isDisplayOnlyRole: false});
